<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default  {
    name:  'App'
  }
</script>

<style>
body {
  margin: 0 !important;
  height: 100%;
  width: 100%;
}
html, body, td, input, button, select, body, article, section, header, p, menu, textarea {
  font-family: "PingFang SC", "Helvetica Neue", "Arial", "Hiragino Sans GB", "STHeiti", "Microsoft YaHei", sans-serif;
  margin: 0;
  padding: 0;
  font-size: 12px;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue